<template>
  <div :key="componentKey">
    <Pay ref="payDialog" v-model="isDialogVisiblePay" />
    <CreateOrder ref="createOrderDialog" v-model="isDialogVisibleCreateOrder" />
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { ref, provide, watch } from "vue";
import Pay from "@/views/sellstock/transaction/Pay";
import CreateOrder from "@/views/sellstock/transaction/CreateOrder";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const isDialogVisiblePay = ref(false);
const openPaymentDialog = () => {
  isDialogVisiblePay.value = true;
};

const isDialogVisibleCreateOrder = ref(false);
const createOrderDialog = ref<any>(null);
const openCreateOrderDialog = (data?: any) => {
  if (data && createOrderDialog.value) {
    createOrderDialog.value.initData(data);
  }
  isDialogVisibleCreateOrder.value = true;
};

const componentKey = ref(0);

const reloadComponent = (item: any) => {
  if (router.currentRoute.value.fullPath == item.to) {
    componentKey.value += 1;
  }
};

provide("reloadComponent", reloadComponent);
provide("openPaymentDialog", () => {
  isDialogVisiblePay.value = true;
});

provide("openCreateOrderDialog", openCreateOrderDialog);
</script>

<style>
.el-dialog {
  /* position: fixed !important; */
  top: 50px !important;
  left: 50px !important;
  margin: 0 !important;
  z-index: 9999 !important;
}

.el-overlay-dialog {
  display: contents !important;
}
</style>
